import React from 'react';
import timelineBack from "../images/11.png"
import BookYourCallRed from "../images/8.png"
import BellComponent from './BellComponent';

const Timeline = () => {
    return (
        <div className="py-16 px-4 max-w-4xl mx-auto bg-[#edebe6]">

            {/* Header */}
            <div className="text-center mb-16">
                <h2 className="eb-garamond text-4xl md:text-5xl lg:text-6xl font-extralight text-[#f15d16] mb-8">
                    TIME LINE <br />OF  MY  JOURNEY
                </h2>
                <p className="poppins text-gray-600 font-normal text-lg md:text-2xl mx-auto text-justify">
                    Through my struggles I realized that I needed to find a new place
                    where I could be myself. That dream did not come without pain, but
                    pain became part of the progress. Each setback marked a step
                    forward, not just away from my past but towards my true self.
                </p>
            </div>
            <div >
                <img
                    src={timelineBack}
                    alt="Logo"
                    className="mb-3 w-full h-full object-contain"
                />
            </div>
            <div className='pl-[6%]'>
                <BellComponent isWhite={false} />
            </div>
        </div>
    );
};

export default Timeline;